module.exports = __webpack_public_path__ + "img/rosegold@2x.efc7ca9.jpg";